module.exports = __webpack_public_path__ + "ed51068211a62166ca6fe7e58bcf4033.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg83.jpeg
// module id = 98
// module chunks = 0